import { useMutation } from 'react-query';
import api from '~/services/api';
import { parseResponseData } from '../../../../services/utils/parseResponseData';

export const useCreateTeam = options =>
  useMutation(
    data => api.post('/squad/', data).then(parseResponseData),
    options
  );
